module.exports = __webpack_public_path__ + "static/media/caja4.eac1a008.jpg";